/**
 * Magma Dice Color Schemes
 *
 * Color-specific schemes for the magma dice design.
 * Each color defines the player-specific gradient stops for the main body
 * (paint2_linear in the Figma SVG: horizontal 2-stop gradient).
 *
 * The purple geometric frame colors are shared and fixed across all players.
 * The radial gradient inner face uses the player's accent color at the edge.
 */

export interface MagmaDiceColorScheme {
  /** Unique name used as gradient ID prefix to avoid SVG collisions */
  name: string;
  /**
   * 2-stop horizontal linear gradient for the main body surface.
   * Matches paint2_linear_4667_10899 in Figma: [start, end]
   */
  bodyGradient: [string, string];
  /**
   * Color used at the outer edge of the inner face radial gradient.
   * Matches stop offset="1" of paint13_radial in Figma.
   * The center stop is always black (#000000).
   */
  faceRadialColor: string;
}

export const MAGMA_DICE_COLOR_SCHEMES: Record<string, MagmaDiceColorScheme> = {
  red: {
    name: 'red',
    bodyGradient: ['#E43C0B', '#F84D00'],
    faceRadialColor: '#ED1C24'
  },
  blue: {
    name: 'blue',
    bodyGradient: ['#0071BC', '#29ABE2'],
    faceRadialColor: '#0050A0'
  },
  yellow: {
    name: 'yellow',
    bodyGradient: ['#FFCE00', '#FFF810'],
    faceRadialColor: '#F0A800'
  },
  green: {
    name: 'green',
    bodyGradient: ['#128406', '#2BBF02'],
    faceRadialColor: '#0A6004'
  }
};
